import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./style.scss";
class Prize extends Component {
  state = {};
  render() {
    return (
      <div className="prize">
        <img
          alt="logo"
          src={require("./../../assets/images/logo.svg")}
          className="prize-logo"
        ></img>
        <div className="prize-header">THIS WEEK PRIZE</div>
        <div className="prize-body">
          <div className="prize-body-prize">New iWatch 5.0</div>
          <div className="prize-body-comment">For top 7 players each month</div>
          <div className="prize-body-image">
            <img
              alt="prize"
              src={require("./../../assets/images/iWatch.png")}
              style={{ width: "300px", height: "300px" }}
            ></img>
          </div>
          <div className="prize-body-imgComment">
            All of top players get the award
          </div>
          <Link to="/luckygame">
            <button className="prize-body-button">START NOW</button>
          </Link>
        </div>
        <div className="prize-footer">©2018 lucky7.game</div>
      </div>
    );
  }
}

export default Prize;
